import ProviderRequirementsHelpContent from './content/ProviderRequirementsHelpContent';
import HelpTopics from './HelpTopics';
import { PROVIDER_REQUIREMENTS_HELP_CONTENT_ID } from '../../util/userTypeRedirects';

export { PROVIDER_REQUIREMENTS_HELP_CONTENT_ID };

export const REQUIREMENTS_TAB_ID = 'requirements';
export const HELP_TAB_ID = 'help';

const isRequirementsIncomplete = currentUser =>
  currentUser?.attributes?.profile?.publicData?.providerRequirementsComplete !== true;

const helpContentRegistry = {
  [PROVIDER_REQUIREMENTS_HELP_CONTENT_ID]: {
    // Flyout header always says "Help"; per-content titles live in the body (h3)
    titleId: 'HelpFlyout.title',
    // Fallback when tabs are not rendered (should not normally happen).
    component: ProviderRequirementsHelpContent,
    tabs: [
      {
        id: REQUIREMENTS_TAB_ID,
        labelId: 'HelpFlyout.tab.requirements',
        component: ProviderRequirementsHelpContent,
        // Requirements tab only shows while the synced completion flag is not true.
        isVisible: isRequirementsIncomplete,
      },
      {
        id: HELP_TAB_ID,
        labelId: 'HelpFlyout.tab.help',
        component: HelpTopics,
      },
    ],
  },
};

/**
 * Look up registered help content by id.
 *
 * @param {string} contentId
 * @returns {{
 *   titleId: string,
 *   component: React.ComponentType,
 *   tabs?: Array<{id: string, labelId: string, component: React.ComponentType, isVisible?: Function}>
 * } | null}
 */
export const getHelpContent = contentId => {
  if (!contentId || !helpContentRegistry[contentId]) {
    return null;
  }
  return helpContentRegistry[contentId];
};

export default helpContentRegistry;
